import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaSearch, FaTicketAlt, FaEye } from "react-icons/fa";
import { MdDiscount, MdTrendingUp } from "react-icons/md";
import { fetchCouponsAction } from "../../redux/actions/couponActions";
import CouponDetailsOffcanvas from "./CouponDetailsOffcanvas";
import Pagination from "../../../helper/Pagination";
import "./AllCoupon.css";

const AllCoupon = () => {
  const dispatch = useDispatch();
  const { coupons, pagination, loading, error } = useSelector((state) => state.coupon);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    dispatch(fetchCouponsAction({ search: searchTerm, page: currentPage, limit: 10 }));
  }, [dispatch, searchTerm, currentPage]);

  const handleRowClick = (coupon) => {
    setSelectedCoupon(coupon);
    setShowOffcanvas(true);
  };

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
    setSelectedCoupon(null);
  };

  const totalCoupons = coupons.length;
  const activeCoupons = coupons.filter((c) => c.valid).length;
  const totalUsage = coupons.reduce((sum, c) => sum + c.usedCount, 0);

  return (
    <>
      <div className="page-container">
        <div className="page-card scroll-container">
          <div className="form-header-AllCoupon d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-1">
                <FaTicketAlt className="me-2 text-primary" />
                Coupon Management
              </h5>
              <p className="text-muted mb-0">
                Manage and monitor your discount coupons
              </p>
            </div>
            <div className="d-flex gap-3">
              <div className="stats-card">
                <div className="stats-icon bg-primary">
                  <FaTicketAlt />
                </div>
                <div>
                  <div className="stats-number">{totalCoupons}</div>
                  <div className="stats-label">Total Coupons</div>
                </div>
              </div>
              <div className="stats-card">
                <div className="stats-icon bg-success">
                  <MdDiscount />
                </div>
                <div>
                  <div className="stats-number">{activeCoupons}</div>
                  <div className="stats-label">Active</div>
                </div>
              </div>
              <div className="stats-card">
                <div className="stats-icon bg-info">
                  <MdTrendingUp />
                </div>
                <div>
                  <div className="stats-number">{totalUsage}</div>
                  <div className="stats-label">Total Usage</div>
                </div>
              </div>
            </div>
          </div>
          <div className="table-section">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div className="d-flex align-items-center gap-2">
                <h6 className="mb-0">Coupon List :</h6>
                <span className="text-dark">{coupons.length} items</span>
              </div>
              <div className="position-relative d-flex justify-content-end mb-1">
                <input
                  type="search"
                  placeholder="Search coupons..."
                  className="form-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value.trimStart())}
                  style={{ width: "200px" }}
                />
                {searchTerm === "" && (
                  <div
                    className="position-absolute"
                    style={{
                      top: "50%",
                      right: "13px",
                      transform: "translateY(-50%)",
                      color: "#666",
                    }}
                  >
                    <FaSearch />
                  </div>
                )}
              </div>
            </div>
            <div className="table-scroll-wrapper">
              <table className="partners-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon Details</th>
                    <th>Coupon ID</th>
                    <th>Discount</th>
                    <th>Currency</th>
                    <th>Duration</th>
                    <th>Usage</th>
                    <th>Users</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "40px",
                          color: "#666",
                        }}
                      >
                        <div className="loading-spinner">
                          <div className="spinner"></div>
                          <p>Loading...</p>
                        </div>
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#d32f2f",
                        }}
                      >
                        Error: {error}
                      </td>
                    </tr>
                  ) : coupons.length === 0 ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          color: "#666",
                        }}
                      >
                        No coupon data available
                      </td>
                    </tr>
                  ) : (
                    coupons.map((coupon, index) => (
                      <tr
                        key={coupon._id}
                        onClick={() => handleRowClick(coupon)}
                        style={{ cursor: "pointer" }}
                        className="table-row-hover"
                      >
                        <td>{(currentPage - 1) * pagination.itemsPerPage + index + 1}</td>
                        <td>
                          <div className="d-flex align-items-center">
                            <div className="coupon-icon me-2">
                              <FaTicketAlt className="text-primary" />
                            </div>
                            <div>
                              <div className="fw-bold text-primary">
                                {coupon.name}
                              </div>
                              {/* <small className="text-muted">{coupon.stripeCouponId}</small> */}
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className="badge bg-light text-dark border">
                            {coupon.stripeCouponId}
                          </span>
                        </td>
                        <td>
                          <div className="discount-badge">
                            {coupon.percent_off ? (
                              <span className="badge bg-success">
                                {coupon.percent_off}% OFF
                              </span>
                            ) : (
                              <span className="badge bg-info">
                                {coupon.currency === "jpy" ? "¥" : "$"}
                                {coupon.currency === "jpy"
                                  ? coupon.amount_off
                                  : (coupon.amount_off / 100).toFixed(2)}{" "}
                                OFF
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <span className="badge bg-secondary">
                            {coupon.currency?.toUpperCase()}
                          </span>
                        </td>
                        <td>
                          <span className="text-capitalize fw-medium">
                            {coupon.duration}
                          </span>
                        </td>
                        <td>
                          <div className="usage-stats">
                            <span className="fw-bold text-primary">
                              {coupon.usedCount}
                            </span>
                            <small className="text-muted d-block">
                              times used
                            </small>
                          </div>
                        </td>
                        <td>
                          <div className="usage-stats">
                            <span className="fw-bold text-info">
                              {coupon.uniqueUsers}
                            </span>
                            <small className="text-muted d-block">
                              unique users
                            </small>
                          </div>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <span
                              className={`status-badge ${
                                coupon.valid ? "success" : "danger"
                              }`}
                            >
                              {coupon.valid ? "Active" : "Inactive"}
                            </span>
                            {/* <FaEye size={12}  onClick={(e) => {
                                e.stopPropagation();
                                handleRowClick(coupon);
                              }}
                              title="View Details" /> */}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            
            <Pagination
              currentPage={currentPage}
              totalPages={pagination.totalPages}
              totalItems={pagination.totalItems}
              itemsPerPage={pagination.itemsPerPage}
              onPageChange={setCurrentPage}
            />
          </div>
        </div>
      </div>

      <CouponDetailsOffcanvas
        isOpen={showOffcanvas}
        onClose={handleCloseOffcanvas}
        coupon={selectedCoupon}
      />
    </>
  );
};

export default AllCoupon;
